import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import OrderList, { DispatchProps, OwnProps, StateProps } from './OrderList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getOrders } from 'src/store/actions/order-actions';
import { selectNameSerTypesDropDown } from '../../../../../../store/selectors/service-types-selectors';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.orders.data,
        inProgress: state.orders.inProgress,
        serviceTypes: selectNameSerTypesDropDown(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getOrders(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}
const OrderListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderList);

export default OrderListScreen;
